import casesAPI from '@/api/resources/cases'
import caseForms from './caseForms'
import _ from 'lodash'
import moment from 'moment'

const state = {
  allCases: [],
  filteredCases: [],
  caseLog: [],
  caseLogManagersFlow: [],
  caseInvoices: [],
  caseVendorInvoices: [],
  caseServices: [],
  caseManager: null,
  editCrewDialog: false,
  editCrewCaseId: null,
  crewDialogCase: null
}

const getters = {
  getEditCrewDialog: state => state.editCrewDialog,
  getEditCrewCaseId: state => state.editCrewCaseId,
  getAllCases: state => state.allCases,
  getFilteredCases: state => state.filteredCases,
  getCaseById: state => (id) => state.allCases.find(ca => ca.id === id),
  getAllCompletedCases: state => {
    return _.filter(state.allCases, (c) => c.status === 'closed')
  },
  casesWithServicesCommissions: (state, rootGetters) => {
    return _.map(rootGetters.getAllCompletedCases, (c) => {
      let totalPrice = 0
      c.services = _.map(c.services, (s) => {
        let productObj = rootGetters.getProductById(s.id)
        s.service = productObj
        s.commission = (productObj !== undefined && productObj.commission !== null) ? productObj.commission * s.pivot.quantity : 0
        totalPrice += (productObj !== undefined && productObj.commission !== null) ? productObj.price * s.pivot.quantity : 0
        return s
      })
      const casketID = rootGetters.filterCasketFromLinkedProducts(c.services)
      const casket = rootGetters.getCasketById(casketID)
      const casketCommission = casket && casket.commission ? casket.commission : 0
      totalPrice += casket && casket.commission ? casket.price : 0
      c.commissions = _.sumBy(c.services, 'commission') + casketCommission
      c.casket = casket
      c.totalPrice = totalPrice
      return c
    })
  },
  getAllCompletedGroupedCases: (state, rootGetters) => (fromDate, toDate, userId) => {
    let filteredCases = rootGetters.casesWithServicesCommissions
    if (userId !== null) {
      filteredCases = filteredCases.filter(c => c.manager_name === userId)
    }
    if (fromDate !== null) {
      filteredCases = filteredCases.filter(c => moment(c.created_at).format('YYYY-MM-DD') >= moment(fromDate).format('YYYY-MM-DD'))
    }
    if (toDate !== null) {
      filteredCases = filteredCases.filter(c => moment(c.created_at).format('YYYY-MM-DD') <= moment(toDate).format('YYYY-MM-DD'))
    }
    return _.groupBy(filteredCases, 'manager_name')
  },
  caseLog: state => state.caseLog,
  caseLogManagersFlow: state => state.caseLogManagersFlow,
  currentCaseInvoices: state => state.caseInvoices,
  currentCaseVendorInvoices: state => state.caseVendorInvoices,
  caseManager: state => state.caseManager,
  getCrewDialogCase: state => state.crewDialogCase
}

const actions = {
  loadAllCases ({ commit }) {
    return new Promise((resolve, reject) => {
      casesAPI.loadCases().then(result => {
        commit('receiveCases', result)
        resolve()
      }, () => {})
    })
  },
  getCaseLog ({ dispatch, commit }, casesid) {
    commit('clearCaseLog')
    return new Promise((resolve, reject) => {
      casesAPI.loadLogForCase(casesid).then(result => {
        commit('receiveCaseLog', result)
        dispatch('processManagersFlow', { id: casesid, result: result })
        resolve()
      }, () => {})
    })
  },
  getCaseManager ({ commit }, casesid) {
    return new Promise((resolve, reject) => {
      casesAPI.loadCaseManager(casesid).then(result => {
        commit('receiveCaseManager', result)
        resolve()
      })
    })
  },
  processManagersFlow ({ commit, getters, state }, logData) {
    let managersData = _.filter(logData.result, c => {
      return c.action === 'Case manager changed' || c.action === 'Commissions changed case manager' || 'Commissions changed'
      // return c.action === c.action === 'Commissions changed case manager' || 'Commissions changed'
    })

    managersData = _.map(managersData, (action) => {
      if (action.payload && getters.getCaseManagerById(action.payload.manager_id)) {
        return {
          id: action.id,
          manager: getters.getCaseManagerById(action.payload.manager_id),
          created_at: action.created_at,
          commissions: action.payload.commissions || 0
        }
      } else {
        return false
      }
    }).filter(i => i)

    commit('setManagerFlow', managersData)
  },
  changeCaseManagerCommissions ({ commit }, data) {
    return new Promise((resolve, reject) => {
      casesAPI.changeCaseManagerCommissions(data.case_id, { commissions: data.commissions }).then((result) => {
        resolve(result)
      })
    })
  },
  setCaseManagerCommissions ({ commit }, data) {
    return new Promise((resolve, reject) => {
      casesAPI.changeCaseManagerCommissions(data.case_id).then((result) => {
        resolve(result)
      })
    })
  },
  getCaseInvoices ({ commit }, casesid) {
    return new Promise((resolve, reject) => {
      casesAPI.getLinkedInvoices(casesid).then(result => {
        commit('receiveCaseInvoices', result)
        resolve(true)
      }, () => {})
    })
  },
  approveCase ({ commit }, caseId) {
    return new Promise((resolve, reject) => {
      casesAPI.approveCase(caseId).then(result => {
        resolve(true)
      }, () => {})
    })
  },
  markInvoiceAsPaid ({ commit }, caseId) {
    return new Promise((resolve, reject) => {
      casesAPI.markInvoiceAsPaid(caseId).then(result => {
        commit('markInvoiceAsPaid')
        resolve()
      }, () => {})
    })
  },
  loadCase ({ commit }, caseId) {
    return new Promise((resolve, reject) => {
      casesAPI.loadCase(caseId).then(result => {
        const object = result[0] ? result[0] : result
        commit('receiveCase', object)
        resolve(result)
      })
    })
  },
  updateCase ({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      casesAPI.updateCase(data.case_id, data.payload).then(() => {
        dispatch('loadCase', data.case_id).then((result) => {
          resolve(result)
        })
      })
    })
  },
  loadPdfInvoice ({ commit }, answersId) {
    return new Promise((resolve, reject) => {
      casesAPI.loadPDF(answersId).then((result) => {
        resolve(result)
      })
    })
  },
  loadPdfAgreement ({ commit }, answersId) {
    return new Promise((resolve, reject) => {
      casesAPI.loadPDFAgreement(answersId).then((result) => {
        resolve(result)
      })
    })
  },
  setCrewDialogCase ({ commit }, caseObject) {
    commit('setCrewDialogCase', caseObject)
  }
}

const mutations = {
  receiveCaseLog (state, caseLog) {
    state.caseLog = caseLog
  },
  setManagerFlow (state, flow) {
    state.caseLogManagersFlow = flow
  },
  receiveCaseManager (state, manager) {
    state.caseManager = manager || null
  },
  receiveCase (state, updatedCase) {
    const item = state.allCases.find(item => item.id === updatedCase.id)
    if (item) Object.assign(item, updatedCase)
  },
  receiveCaseInvoices (state, caseInvoices) {
    if (caseInvoices !== undefined) {
      state.caseInvoices = _.filter(caseInvoices.data.additional_data, (i) => {
        return (i.vendors_id === 0 || i.vendors_id !== null)
      })
      state.caseVendorInvoices = _.filter(caseInvoices.data.additional_data, (i) => {
        return (i.vendors_id !== 0 || i.vendors_id === null)
      })
    }
  },
  markInvoiceAsPaid (state) {
    if (state.caseInvoices.length) {
      state.caseInvoices[state.caseInvoices.length - 1].status = 'paid'
    }
  },
  clearCaseLog (state) {
    state.caseLog = []
  },
  receiveCases (state, allCases) {
    state.allCases = allCases
  },
  switchCrewDialog (state) {
    state.editCrewDialog = !state.editCrewDialog
  },
  setEditCaseCrewId (state, caseId) {
    state.editCrewCaseId = caseId
  },
  unsetEditCaseCrewId (state) {
    state.editCrewCaseId = null
  },
  setCrewDialogCase (state, caseObject) {
    state.crewDialogCase = caseObject
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  modules: {
    caseForms
  }
}



// WEBPACK FOOTER //
// ./src/store/cases.js